import * as React from 'react'
import * as styles from './Smile.module.scss'
import * as cn from 'classnames'

// TODO(AVWebStorefront-745): This is just a place holder
const Smile = ({hasAltTheme}: {hasAltTheme: boolean}) => (
  <svg className={cn(styles.Smile, {[styles.hasAltTheme]: hasAltTheme})} viewBox="0 0 245.32178 57.484001" xmlns="http://www.w3.org/2000/svg">    <path d="M 0,4.657 C 0.158,3.634 0.967,2.855 2.091,2.855 c 0.524,0 1.118,0.171
    1.744,0.562 34.731,21.781 77.697,34.903 122.067,34.903 29.943,0 62.841,-6.701 93.117,-20.544
    4.563,-2.079 8.386,3.239 3.922,6.811 C 195.933,46.059 156.778,57.484 123.062,57.484 75.814,57.484
    33.267,38.654 1.058,7.316 0.426,6.702 0.094,6.029 0,5.397 l 0,-0.74 z M 200.663,8.042
    C 208.649,2.012 219.267,0 228.071,0 c 8.235,0 14.886,1.763 16.302,3.648 2.976,3.933 -0.766,31.201
    -15.261,44.206 -2.218,2.014 -4.328,0.929 -3.35,-1.699 3.259,-8.722 10.553,-28.306 7.096,-33.054
    -3.452,-4.759 -22.835,-2.268 -31.527,-1.145 -1.347,0.171 -2.113,-0.38 -2.225,-1.201 l 0,-0.443 c
    0.091,-0.712 0.596,-1.543 1.557,-2.27 z" />
  </svg>
)

export default Smile
